export default __webpack_public_path__ + "static/media/FAQ_12_3.d287e4ab.png";